module.exports = __webpack_public_path__ + "static/media/1.79dc6dbe.png";